/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import * as ChannelStickerActionCreators from '@app/actions/ChannelStickerActionCreators';
import {CloudUpload} from '@app/lib/CloudUpload';
import type {GuildStickerRecord} from '@app/records/GuildStickerRecord';
import DraftStore from '@app/stores/DraftStore';

export function shouldSetPendingSticker(channelId: string): boolean {
	const draft = DraftStore.getDraft(channelId);
	const hasTextContent = draft && draft.trim().length > 0;
	const hasAttachments = CloudUpload.getTextareaAttachments(channelId).length > 0;
	return hasTextContent || hasAttachments;
}

export function setPendingSticker(channelId: string, sticker: GuildStickerRecord): void {
	ChannelStickerActionCreators.setPendingSticker(channelId, sticker);
}
